export enum enumIsfShipmentCode {
  HOUSE = 'BM',
  OCEAN = 'OB',
  MB = 'MB',
  'BM' = 'HOUSE',
  'OB' = 'MASTER',
}
